import React, { useState } from "react";
import cancel from "assets/cancel.png";

function ModalWarning(props) {

  return (
    <div className="container ModalToast">
      <div className="columns">
          <a className="close" onClick={props.openModal}><img src={cancel} /> </a>
          <div className="column kModal">
             <p>
                 Lütfen KVKK metnini onaylayın.
             </p>
          </div>
      </div>
    </div>
  );
}

export default ModalWarning;
